import { Skeleton } from '@/components/ui/skeleton'
import { titleHintFromPathOrId } from '@/lib/document-deep-link-cold-load'
import { getPendingDocumentDeepLink } from '@/lib/document-deep-link-pending'
import { testIds } from '@/lib/test-ids'

/**
 * Mid-load frame for cold document deep links (every-frame craft).
 * Shown instead of Home while pending restore runs - never paint Home for a doc URL.
 */
export function DocumentDeepLinkLoadingShell({
  pathOrId,
}: {
  pathOrId?: string | null
}) {
  const pending = getPendingDocumentDeepLink()
  const hintPath = pathOrId ?? pending?.pathOrId ?? null
  const titleHint = hintPath ? titleHintFromPathOrId(hintPath) : 'Document'

  return (
    <div
      className="flex h-full min-h-0 w-full flex-col bg-background"
      data-testid={testIds.documentViewer.deepLinkLoadingShell}
      role="status"
      aria-busy="true"
      aria-label={`Opening ${titleHint}`}
    >
      <div className="flex items-center gap-3 border-b border-border px-4 py-3">
        <Skeleton className="h-5 w-48 max-w-[50%]" />
        <div className="ml-auto flex gap-2">
          <Skeleton className="h-8 w-8 rounded-md" />
          <Skeleton className="h-8 w-8 rounded-md" />
        </div>
      </div>
      <div className="flex-1 space-y-3 overflow-hidden px-6 py-6">
        <Skeleton className="h-8 w-2/3 max-w-md" />
        <Skeleton className="h-4 w-full max-w-2xl" />
        <Skeleton className="h-4 w-full max-w-2xl" />
        <Skeleton className="h-4 w-5/6 max-w-xl" />
        <Skeleton className="mt-6 h-4 w-full max-w-2xl" />
        <Skeleton className="h-4 w-4/5 max-w-xl" />
        <Skeleton className="h-4 w-full max-w-2xl" />
      </div>
    </div>
  )
}
